










































































































import { DraftCompanyParams } from '@/store/interfaces/drafts';
import drafts from '@/store/types/drafts';
import { Component, Vue } from 'vue-property-decorator';
import { Action, Getter } from 'vuex-class';
import InboundCard from './inboundCard.vue';
import DescriptionValue from '@/components/Reusable/descriptionValue.vue';
import profileForm from './forms/profile.vue';
import location from '@/store/types/location';
import { VuexFunction } from '@/ts/axios';

@Component({
  components: { InboundCard, DescriptionValue, profileForm, },
})
export default class Profile extends Vue {
  isStateCountryLoading = true;
  edit = false;

  editThrows(value: boolean): void {
    this.edit = value;
  }

  async mounted(): Promise<void> {
    await this.ListState('SV');
    this.isStateCountryLoading = false;
  }

  get ownerOfCompany(): string {
    return this.draftCompany.company_kind === 'natural'
      ? 'propietario'
      : 'representante legal';
  }

  @Getter(`drafts/${drafts.getters.GET_DRAFT_COMPANY}`)
  draftCompany!: DraftCompanyParams;

  @Action(`country/${location.actions.STATE_LIST}`) ListState!: VuexFunction;
}
